import _debug from 'debug';
import React, { Component, PropTypes } from 'react';
import { IconMenu, MenuItem } from 'react-toolbox/lib/menu';
import { logout } from 'lib/network/webapi';
import { bindActionCreators } from 'redux';
import ProgressBar from 'react-toolbox/lib/progress_bar';
import NotificationSystem from 'react-notification-system';
import * as actions from 'state/modules/topBar';
import * as assigncreator from 'state/modules/assign';
import { connect } from 'react-redux';
import styles from './TopBar.css';

const debug = _debug('app:TopBar');
const style = {
  Wrapper: {
    display: 'flex',
    justifyContent: 'center'
  },
  Containers: {
    DefaultStyle: {
      width: 420
    },
    tc: { // Override the tc(top center)
      top: '1.956em'
    },
  },
  NotificationItem: { // Override the notification item
    DefaultStyle: {
      fontSize: '1.0rem'
    },
    success: { // Override the success notification item
      backgroundColor: '#64be88',
      borderTop: 'none',
      color: '#eeeeee'
    }
  },
  Dismiss: { // Override the Dismiss item
    DefaultStyle: {
      fontFamily: 'Arial',
      fontSize: '2.0625rem',
      backgroundColor: 'transparent',
      borderRadius: 'inherit',
      fontWeight: 'inherit',
      top: '0.3em',
    }
  }
};

class TopBar extends Component {

  static defaultProps = {
    username: '...'
  }

  static propTypes = {
    username: PropTypes.string,
    getUserName: PropTypes.func,
    loginName: PropTypes.string,
    isMarketOpen: PropTypes.string,
    dataIsLoading: PropTypes.bool,
    marketCode: PropTypes.string,
    currentLanguage: PropTypes.string,
    updateSelectedLanguage: PropTypes.func,
    progressBar: PropTypes.shape({})
  }

  constructor(props) {
    super(props);
    debug('In the TopBar');
  }

  state = {
    notificationSystem: null,
    notify: 0
  }

  componentWillMount() {
    this.props.getUserName();
  }

  loggedOut = () => {
    logout();
  }

  translate = () => {
    const { currentLanguage } = this.props;
    if (currentLanguage === 'en') {
      this.props.updateSelectedLanguage('es');
    } else {
      this.props.updateSelectedLanguage('en');
    }
  }

  renderProgressBars = () => {
    const { progressBar } = this.props;
    return Object.keys(progressBar).map((data) => {
      if (!progressBar[data].show) {
        return <div key={data} />;
      }
      if (this.state.notify < 1) {
        if (this.props.marketCode !== '') {
          if (this.props.isMarketOpen !== null && this.props.loginName !== null) {
            if (this.notificationSystem) {
              this.setState({ notify: 1 });
              this.notificationSystem.addNotification({
                message: `${this.props.marketCode} Logged In`,
                level: 'success',
                position: 'tc',
                autoDismiss: 0,
                dismissible: true
              });
            }
          } else {
            this.setState({ notify: 1 });
            this.notificationSystem.addNotification({
              message: `${this.props.loginName} Logged In`,
              level: 'success',
              position: 'tc',
              autoDismiss: 0,
              dismissible: true
            });
          }
        }
      }
      if ((parseInt((progressBar[data].progress / progressBar[data].maxValue) * 100, 10)) > 100) {
        return (
          <div className={styles.progressView} key={data} >
            <span className={styles.progressBarTitle}>
              { `${progressBar[data].title} - 100% Completed` }
            </span>
            <ProgressBar
              mode="determinate"
              max={progressBar[data].maxValue}
              value={progressBar[data].progress}
              theme={styles}
            />
          </div>
        );
      }
      return (
        <div className={styles.progressView} key={data} >
          <span className={styles.progressBarTitle}>
            {
              `${progressBar[data].title}  -  ${parseInt((progressBar[data].progress / progressBar[data].maxValue) * 100, 10)}% Completed`
            }
          </span>
          <ProgressBar
            mode="determinate"
            max={progressBar[data].maxValue}
            value={progressBar[data].progress}
            theme={styles}
          />
        </div>
      );
    });
  }

  render() {
    if (__MANAGE__) {
      return (
        <div className={styles.flexManageAppbar}>
          <div className={styles.headerDiv}>
            <div className={styles.headerCenter}>Leads</div>
          </div>
          <div className={styles.userDropDown}>
            <div className={styles.headerAdd}>
              <input
                type="image"
                src="static/add_leads.png"
                alt="Add"
                className={styles.addLeads}
              />
            </div>
          </div>
        </div>
      );
    }
    return (
      <div className={styles.flexAppbar}>
        <div className={styles.leftGroup}>
          <div className={styles.logo}>
            <img role="presentation" src="static/logo.png" />
          </div>
          <div className={styles.progessBarContainer}>
            {!this.props.dataIsLoading && this.renderProgressBars()}
          </div>
        </div>
        <div className={styles.userDropDown}>
          <label htmlFor="message" className={styles.message}>Welcome &nbsp;{<strong className={styles.username}>{this.props.username}</strong>} </label>
        </div>
        <NotificationSystem
          ref={ref => (this.notificationSystem = ref)}
          style={style}
        />
        <div className={styles.logOut}>
          <IconMenu
            icon={<img role="presentation" className={styles.topImage} src="static/baseline_more_vert_white_18dp.png" />}
            position="topLeft"
            theme={styles}
            menuRipple
          >
            <MenuItem
              value={this.props.currentLanguage === 'en' ? 'Spanish' : 'English'} theme={styles}
              caption={this.props.currentLanguage === 'en' ? 'Español' : 'English'} onClick={this.translate}
            />
            <MenuItem value="logOut" theme={styles} caption="Log Out" onClick={this.loggedOut} />
          </IconMenu>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  username: state.topBar.username,
  loginName: state.assign && state.assign.loginName,
  marketCode: state.assign && state.assign.marketCode,
  isMarketOpen: state.assign && state.assign.isMarketOpen,
  currentLanguage: state.assign && state.assign.currentLanguage
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    Object.assign(
      {},
      actions,
      assigncreator
    ), dispatch
  );
}
/*
Following Actions are being mapped to props
  1) getUserName
*/

export default connect(mapStateToProps, mapDispatchToProps)(TopBar);



// WEBPACK FOOTER //
// ./src/containers/TopBar/TopBar.js